import React from 'react';
import PropTypes from 'prop-types';
import { apiZedocGetPatientProjectBundleToken } from '../../../common/api/zedoc';
import IframeEmbed from '../../../components/patients/IframeEmbed';

const PatientProjectBundle = ({ projectId, participationId }) => {
  // Debug logging
  console.log('PatientProjectBundle props:', { projectId, participationId });

  // Validate required props
  if (!projectId || !participationId) {
    return (
      <div
        style={{
          padding: '20px',
          textAlign: 'center',
          color: '#d32f2f',
        }}
      >
        <h3>Unable to load Patient-Project Bundle</h3>
        <p>
          {!projectId && 'Project ID is missing. '}
          {!participationId && 'Participation ID is missing. '}
        </p>
        <p>Please ensure the patient has an active project participation.</p>
      </div>
    );
  }

  return (
    <IframeEmbed
      apiSpec={apiZedocGetPatientProjectBundleToken}
      params={{
        projectId,
        participationId,
      }}
      title="Patient-Project Bundle"
      toolName="patient-project bundle tool"
    />
  );
};

PatientProjectBundle.propTypes = {
  projectId: PropTypes.string,
  participationId: PropTypes.string,
};

PatientProjectBundle.defaultProps = {
  projectId: null,
  participationId: null,
};

export default PatientProjectBundle;
